// extracted by mini-css-extract-plugin
module.exports = {"title":"HoverCopyTip_title__7RWma"};